import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AlcoConversionTAVForm from './AlcoConversionTAVForm';
import AlcoConversionElecDensimeterForm from './AlcoConversionElecDensimeterForm';

export default function AlcoholFormTabs(props) {
  const {
    formik,
  } = props;
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    formik.setFieldValue('isElectronicDensimeter', newValue === 'elecdensimeter');
    localStorage.setItem('last_alco_conversion_tab', newValue);
    if (newValue === 'elecdensimeter') {
      formik.setFieldValue('tavTemperature', '20.0');
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      width: ' 100%',
    }}
    >
      <TabContext value={formik.values.isElectronicDensimeter ? 'elecdensimeter' : 'tav'}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} centered>
            <Tab label={t('alcohol_form.with_elec_densimeter')} value="elecdensimeter" />
            <Tab label={t('alcohol_form.with_tav')} value="tav" />
          </TabList>
        </Box>
        <TabPanel value="tav" sx={{ p: 0 }}>
          <AlcoConversionTAVForm
            formik={formik}
          />
        </TabPanel>
        <TabPanel value="elecdensimeter" sx={{ p: 0 }}>
          <AlcoConversionElecDensimeterForm
            formik={formik}
          />
        </TabPanel>
      </TabContext>

    </Box>

  );
}
